import { Path, Rect, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M8 19.25H16" />
		<Rect x="5" y="4" width="14" height="11" fill="currentColor" stroke="none" />
	</SVG>
);
